import { render, staticRenderFns } from "./OpenQuestionWithDynamicInputFields.vue?vue&type=template&id=6b04a042&"
import script from "./OpenQuestionWithDynamicInputFields.vue?vue&type=script&lang=js&"
export * from "./OpenQuestionWithDynamicInputFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports